import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * AstrologerRoute — restricts access to astrologer-only routes.
 * Unauthenticated users → /login
 * Authenticated non-astrologers → /unauthorized
 */
const AstrologerRoute = ({ children }) => {
  const { user, isAuthenticated } = useSelector(state => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user || user.role !== 'astrologer') {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default AstrologerRoute;
